import { ReactElement } from 'react'
import CheckIcon from '@mui/icons-material/Check'
import { Translate2 } from 'common'

export const BundledTag = (): ReactElement => {
  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        backgroundColor: '#ecf5e1',
        color: '#000',
        fontWeight: '500',
        fontSize: '14px',
        padding: '4px 10px',
        borderRadius: '4px',
        //   cursor: default
        width: 'fit-content',
        //   transition: all 0.2s ease
        marginBottom: '8px',
      }}
    >
      {Translate2('bundled')}{' '}
      <CheckIcon
        sx={{
          fontSize: '14px',
        }}
      />
    </div>
  )
}
